/*=========================================================================================
  File Name: moduleSitesettingGetters.js
  Description: Site Setting Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {};
